module.exports = __webpack_public_path__ + "img/Frame 1088two.512edab5.png";